import "isomorphic-fetch";
import { BatchRequestStep, Client, BatchResponseContent } from "@microsoft/microsoft-graph-client/lib/src/browser";
import { DriveItemSearchResult } from "../../interfaces/IDriveItemSearchResult";
import { IBatchSearchResult } from "../../interfaces/IBatchSearchResult";
import { BaseBatch } from "./baseBatch";

export class SearchBatchRequestHelper extends BaseBatch {
    constructor(client: Client) {
        super(client);
    }

    process = async (itemsToProcess: DriveItemSearchResult[], batchRequestCallback: (item: any, index: number) => BatchRequestStep) => {
        const batchRequests: BatchRequestStep[] =
            itemsToProcess.map(batchRequestCallback);

        const batchResponse = await this.buildBatchResponse(batchRequests);
        return await this.getBatchResponse(itemsToProcess, batchResponse);
    }

    private async getBatchResponse(itemsToProcess: any[], batchResponse: any): Promise<IBatchSearchResult[]> {
        const batchResponseContent = new BatchResponseContent(batchResponse);
        return await Promise.all(itemsToProcess.map((item, index) => (this.getBatchData(batchResponseContent, item, index))));
    }

    private async getBatchData(batchResponseContent: BatchResponseContent, item: DriveItemSearchResult, index: number): Promise<IBatchSearchResult> {
        let response = await batchResponseContent.getResponseById(index.toString()).json();
        return {
            name: item.name,
            driveId: item.driveId,
            itemId: item.id,
            webUrl: item.webUrl,
            metadata: response,
        }
    }
}